import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { useRoute } from '@react-navigation/native';
import BatchListContent from '@v2/pages/common/components/BatchListContent/BatchListContent';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { getNCFileByPartId } from '@reducers/manufacture';
import { View } from 'react-native';
import { DETAILS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import { isWeb, parseRouteParamAsNumber } from '@helpers';

interface ToolsDetailsBatchProps {}

const ToolsDetailsBatchComponent: FC<ToolsDetailsBatchProps> = ({
  getTools,
  clearTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
}) => {
  const title = useTitle();
  const route = useRoute();

  usePartDetails({
    clearTools,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    getNCFileByPartId,
    operationsSearch,
  });

  const ncFileId = parseRouteParamAsNumber(route.params?.ncFileId);

  return (
    <DetailsPageWrapper title={title.batch}>
      <View style={DETAILS_SCREENS_CONTAINER_STYLES}>
        <BatchListContent
          noMachine
          ncFileId={ncFileId}
          noSearchScreen
          backgroundColorForTile={!isWeb ? 'Background/Light/Field on Panel' : 'Background/Light/Field'}
        />
      </View>
    </DetailsPageWrapper>
  );
};

const ToolsDetailsBatch = connect(({}) => ({}), {
  getProductionBatchByPart,
  getTools,
  clearTools,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
})(ToolsDetailsBatchComponent);

export { ToolsDetailsBatch };
